import { z } from 'zod';

const numericString = (label, { min = 0, allowEmpty = true } = {}) =>
  z
    .string()
    .optional()
    .refine((v) => {
      if (allowEmpty && (v === '' || v == null)) return true;
      const n = Number(v);
      return !isNaN(n) && n >= min;
    }, `${label} deve ser um número válido${min > 0 ? ` ≥ ${min}` : ''}`);

export const productSchema = z.object({
  sku: z.string().min(1, 'SKU é obrigatório').max(50, 'SKU muito longo'),
  nome: z.string().min(1, 'Nome é obrigatório').max(200, 'Nome muito longo'),
  preco: z
    .string()
    .min(1, 'Preço é obrigatório')
    .refine((v) => !isNaN(Number(v)) && Number(v) > 0, 'Preço deve ser maior que zero'),
  custo_medio: numericString('Custo médio'),
  unidade: z.string().min(1, 'Unidade é obrigatória'),
  peso_bruto: numericString('Peso bruto'),
  peso_liquido: numericString('Peso líquido'),
  largura: numericString('Largura'),
  altura: numericString('Altura'),
  comprimento: numericString('Comprimento'),
  categoria: z.string().optional(),
  descricao: z.string().optional(),
  imagem_url: z
    .string()
    .optional()
    .refine((v) => !v || /^https?:\/\/.+/i.test(v), 'URL inválida'),
  estoquematriz: numericString('Estoque Matriz'),
  estoque2: numericString('Estoque Filial 2'),
  estoque5: numericString('Estoque Filial 5'),
  estoqueSP: numericString('Estoque Filial SP'),
  estoqueES: numericString('Estoque Filial ES'),
  tiny_id: z.string().optional(),
  tiny_id_matriz: z.string().optional(),
  tiny_id_filial2: z.string().optional(),
  tiny_id_filial5: z.string().optional(),
  tiny_id_filialSP: z.string().optional(),
  tiny_id_filialES: z.string().optional(),
});
